import styled from 'styled-components';

export const Wrapper = styled.div`
	color: #FFFFFF;
	background: #0E0E0F;
	.pop-up-content .container {
    	margin-top: 4.5rem;
  	}
	.plugin-wrapper {
		background-color:  #0E0E0F;
		margin: 2rem auto;
		width: 60rem;
	}
	.loading-container {
		justify-content: center;
		height: 5rem;
	}
	.helper-modal-wrapper {
		padding: 0.5rem 1rem;
		background-color:  #29292C;
		.requirement-icon {
			width: 0.75rem;
			// margin-right: 0.25rem;
		}
		.description {
			margin: 0.5rem 0rem;
		}
		.helper-modal-content {
			display: flex;
			align-items: center;
			.plugin-icon {
				width: 65px;
				height: 65px;
			}
			h2 {
				font-weight: bold;
			}
		}
	}
	.loading-container,
	.flex-center {
		display: flex;
		align-items: center;
	}
	.team-picks {
		padding: 2rem 3rem !important;
		background: #212121;
	}
	.flex-space-between {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.plugin-header {
		padding: 0.25rem 0rem 1rem 0rem;
		border-bottom: 1px solid rgb(168 168 177 / 40%);
		/* box-shadow:0px 1px 1px #DFDFDF; */
	}
	.small-font {
		color: #ffffff;
		font-size: 9px;
		font-weight: bold;
	}
	.plugin-title {
		font-size: 18px;
		font-weight: bold;
	}
	.card-container {
		padding: 2rem 0rem;
		border-bottom: 1px solid #A8A8B1;
		margin-bottom: 0.5rem;
		.card {
			background-repeat: no-repeat;
			background-size: 100% 100%;
			cursor: pointer;
			height: 9rem;
			width: 18rem;
			margin: 1rem;
    		border-radius: 15px;
		}
	}
	.search-plugin-input {
		.ant-input {
			border-left: none;
			border-right: none;
			border-top: none;
			border-bottom: 1px solid #000000;
			border-radius: 0px;
			:focus {
				box-shadow: none;
			}
		}
	}
	p {
		line-height: 1.6;
		font-size: 12px;
		margin-bottom: 4px;
		letter-spacing: -0.1px;
		color: #7f7f7f;
		b {
			font-size: 14px;
		}
	}
	.plugin-icon {
		height: 5rem;
		margin: 0rem 1rem 0rem 0.5rem;
		width: 5rem;
	}
	.cloud-icon {
		height: 3rem;
		width: 3rem;
		margin-right: 1rem;
	}
	.back-btn {
		margin-top: 2rem;
		width: 100%;
	}
	.btn-wrapper {
		margin-top: 2rem;
		.back-btn {
			margin-top: 0rem;
			flex: 1;
		}
		.separator {
			margin: 0.5rem;
		}
	}
	.plugin-list {
		.plugin-list-item {
			margin: 8px 0px;
			cursor: pointer;
		}
		.plugin-list-title {
			font-size: 16px;
			font-weight: bold;
		}
		.plugin-list-author {
			color: #A8A8B1;
			font-size: 11px;
		}
		.plugin-list-bio {
			font-size: 13px;
		}
		.plugin-list-icon {
			height: 4rem;
			margin: 5px 12px 5px 3px;
			width: 4rem;
		}
		// .icon-placeholder {
		// 	background-color: #DFDFDF;
		// 	border-radius: 5px;
		// }
		.add-btn {
			padding: 2px 10px;
			background-color: #3A4FFF;
			border-radius: 13px;
			color: #ffffff;
			cursor: pointer;
			min-width: 3.5rem;
			text-align: center;
		}
		.plugin-card {
			display: inline-block;
			vertical-align: top;
			width: 360px;
			height: 400px;
			margin: 10px;
			h3 {
				font-weight: bold;
				line-height: 24px;
				margin-bottom: 12px;
			}
			.price {
				position: absolute;
				right: 30px;
				top: 30px;
				font-size: 14px;
				line-height: 24px;
				font-weight: bold;
			}
			.plugin-card-img {
				width: 100%;
				height: 200px;
				background-color: #d9d9d9;
				background-position: center;
				background-repeat: no-repeat;
				background-size: cover;
			}
			.plugin-card-info {
				padding: 30px;
				position: relative;
				background-color: #000;
				height: 200px;
			}
		}
	}
	.premium-plugin {
		color: #FF8000;
	}
	@media (max-width: 1200px) {
		.plugin-list {
			padding: 22px 16px;
			.plugin-card {
				width: 100%;
			}
		}
	}
	@media (max-width: 960px) {
		.plugin-wrapper {
			margin: 2rem auto;
			width: 100%;
		}
		.slider-button {
			.anticon svg {
				fill: #707070;
			}
		}
		.plugin-header {
			padding: 0.25rem 1rem 1rem 1rem;
		}
	}
	@media (max-width: 425px) {
        .flex-center {
		    display: block;
            .image-container {
                display: flex;
                justify-content: center;
            }
	    }
		.plugin-header {
			padding: 0.25rem 1rem 1rem 1rem;
		}
		.carousel-container {
			padding: 0 1rem 0 1rem;
		}
    }
`;

export const PluginWrapper = styled.div`
.plugin-wrapper {
	width: 60rem;
	margin-top: 5rem;
	margin-left: auto;
	margin-right: auto;
		.d-flex {
			display: flex;
 		}
		.justify-center {
			justify-content: center;
		}
 		.plugin-header {
			font-size: 18px;
 		}

 .header-wrapper {
	justify-content: space-between ;
    	.header-content-btn {
			margin-top: 1rem;
			background-color: #3A4FFF;
    		color: #fff;
    		border: none;
			justify-content: right;
 		}
}
 .title-content-wrapper {
		margin-top: 1rem;
			.plugin-title-icon {
				width: 30px;
				height: 27px;
			}
			.plugin-title-content {
				margin-left: 1rem;
				text-decoration: underline;
				cursor: pointer;
			}
			.link {
				color: #ffffff !important;
				text-decoration: underline;
			}
 }
 .install-content-wrapper {
	margin-top: 2rem;
	justify-content: space-between ;
	font-size: 18px;
	.install-header {
		margin-top: 10px;
	}
	.filter-content {
		border-left: none !important;
		border-right: none !important;
		border-top: none !important;
		border-bottom: 1px solid #ffffff !important;
		border-radius: 0px;
		background-color: var(--admin_panel_input);
		color: #c4c4c4;
		box-shadow: none;
		width: 20%;
	}
 }
 .horizontal-line {
	padding-bottom: 2rem;
    border-bottom: 1px solid #7A7FB0;
    margin-bottom: 0.5rem;
 }
 .pulgin-img-wrapper {
	 .plugin-image {
		width: -webkit-fill-available;
	}
	 .img-content {
		justify-content: center;
	}
	 .link {
		margin-right: 4px;
		color: #A8A8B1 !important;
		text-decoration: underline;
		cursor: pointer;
	}
 }
} 
@media (max-width: 1200px) {
	.plugin-wrapper {
		width: unset;
		padding: 3rem 3rem 0rem 3rem;
		margin-top: 0px;
	}
}
@media (max-width: 768px) {
	.plugin-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		.plugin-header {
			display: flex;
 		}
 		.header-wrapper {
			flex-direction: column;
			.link {
				display: flex;
				justify-content: center;
			}
		}
		.title-content-wrapper {
			margin-top: 1rem;
			.plugin-title-icon {
				height: 20px;
			}
			.plugin-title-content {
				margin-left: 8px;
			}
 		}
 		.install-content-wrapper {
			margin: 0px;
			flex-direction: column;
			.filter-content {
				width: unset;
			}
		}
		.pulgin-img-wrapper {
	 		.plugin-image {
				width: 20rem;
			}
 		}
	}
}
@media (max-width: 450px) {
	.plugin-wrapper {
 		.header-wrapper {
			text-align: center;
		}
		.footer-title {
			text-align: center;
		}
		.pulgin-img-wrapper {
	 		.plugin-image {
				width: 15rem;
			}
 		}
	}
}
`;

export const PluginHomeWrapper = styled.div`
.plugin-grapic-wrapper {
	.pulgin-img {
		position: fixed;
		width: 100%;
		.plugin-home-icon {
			height: 100vh;
			width: 100%;
		}
	}
	.pulgin-content {
		margin-top: 3rem;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		line-height: 30px;
		.header-content {
			font-size: 35px;
			font-weight: bold;
		}
		.sub-header-content, .link {
			font-size: 16px;
		}
		.link:hover {
			text-decoration: underline;
		}
	}
}
@media (max-width: 1200px) {
	.plugin-grapic-wrapper {
		.pulgin-img {
			.plugin-home-icon {
				height: 50vh;
				width: 100%;
				margin-top: 5rem;
			}
		}
	}
	.pulgin-content {
		.header-content {
			font-size: 18px !important;
		}
		.sub-header-content, .link {
			font-size: 16px !important;
		}
		.sub-header-content {
			margin-left: 2rem;
		}
	}
}
@media (max-width: 550px) {
	.plugin-grapic-wrapper {
		.pulgin-img {
			.plugin-home-icon {
				height: 30vh;
				margin-top: 6rem;
			}
		}
	}
}
`;
export const PluginAppWrapper = styled.div`
	.pulgin-apps-wrapper {
		width: 80rem;
		margin-left: auto;
		margin-right: auto;
		margin-top: 3rem;
		.d-flex {
			display: flex;
		}
		.text-white {
			color: #ffffff;
		}
		.bold {
			font-weight: bold;
		}
		.app-title {
			font-size: 18px;
		}
		.myplugin-link {
			font-size: 16px;
			color: #ffffff;
			text-decoration: underline;
		}
		.justify-content-between {
			justify-content: space-between;
		}
		.text-decoration-underline {
			text-decoration: underline;
		}
		.ml-1 {
			margin-left: 0.5%;
		}
		.cursor-pointer {
			cursor: pointer;
		}
		.plugin-img {
			border-radius: 14px;
			width: 100%;
			margin: 3% 0%;
		}
		.link-text {
			margin-right: 5px;
			font-size: 12px;
			color: #A8A8B1;
			text-decoration: underline;
		}
		.link-text:hover {
			color: #ffffff;
		}
		.plugin-divider {
			border-bottom: 1px solid #B9B9B9 ;
			width: calc(100% + 48px);
			margin: 3% 0%;
		}
		.footer-links-wrapper {
			padding-bottom: 3%;
			.about-wrapper,.blog-wrapper {
				margin-left: 3%;
			}
		}
		.plugin-wrapper {
			margin-top: 3%;
		}
		.header-wrapper {
			margin-bottom: 2rem;
			width: 90%;
				.title-content-wrapper {
					line-height: 1rem;
					margin-top: 3rem;
					.sub-title-font {
						font-size: 14px;
					}
					.exchange-link-label {
						text-decoration: underline;
   						color: #5985ff;
					}
					.ml-3{
						margin: 0px 5px;
					}
					.plugin-title {
						font-size: 16px;
						font-weight: bold;
						color: #ffffff;
					}
					.install-plugin-link {
						color: #ffffff !important;
						text-decoration: underline;
					}
			}
			.plugin-icon {
				margin-top: 15px;
				width: 8rem;
				height: 8rem;
			}
		}
		.sub-title-header {
			margin-top: 3rem;
			font-size: 16px;
		}
		.docs-link {
			margin-top: 2.8rem;
			height: 10%;
		}
		.docs-link-header, .docs-link-footer {
			color: #ffffff;
			font-size: 14px;
			text-align: center;
			margin-right: 10px;
			margin-bottom: 10px;
		}
		.docs-link-footer {
			text-align: start;
			margin-top: 0rem !important;
		}
		.sub-title-content-wrapper {
			margin: 10px 0px 10px 0px;
			.search-label {
				margin-top: 10px;
				font-size: 16px;
				color: #fff;
			}
			.filter-content {
				border-left: none !important;
				border-right: none !important;
				border-top: none !important;
				border-bottom: 1px solid #ffffff !important;
				border-radius: 0px;
				background-color: var(--admin_panel_input);
				color: #c4c4c4;
				box-shadow: none;
				width: 20%;
				margin-left: 1rem;
			}
		}
			.plugin-list-wrapper {
				display: flex;
				flex-wrap: wrap;
				width: 90rem;
				.plugin-list-item {
					width: 30rem;
					cursor: pointer;
					.desecription-content {
						line-height: 0px;
							.plugin-list-title{
								color: #ffffff;
							.plugin-list-font{
									margin-top: 5px;
									font-weight: bold;
								}
							}
					}
					.description-content  > p {
						margin-left: 2rem !important;
						margin: 0px;
					}
					.plugin-list-icon {
						width: 6rem;
						height: 6rem;
					}
				}
				.plugin-card-wrapper {
					width: 90%;
					margin: 1rem 0rem 1rem 0rem;
				}
			}
			.installed-plugin {
				.plugin-content {
					text-align: center;
				}
			}
	}	
@media (max-width: 1440px) {
	.pulgin-apps-wrapper {
		padding: 5rem;
		margin-top: unset;
		width: unset;
		.plugin-list-wrapper {
			width: 100%;
			justify-content: unset !important;
			.plugin-list-item {
				width: 25rem;
			}
		}
	}
}
@media (max-width: 1024px) {
	.pulgin-apps-wrapper {
		width: unset;
		padding: 3rem;
		.plugin-list-wrapper {
			width: unset;
			justify-content: center;
		}
		.docs-link {
			margin-top: 0rem;
		}
		.header-links {
			margin-top: 3%;
		}
		.header-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: center	;
			.title-wrapper {
				.sub-title-font, .plugin-title {
					line-height: 1rem;
				}
			}
		}
		.app-title {
			font-size: 18px;
		}
		.header-links {
			justify-content: center;
		}
	}
}
@media (max-width: 768px) {
	.pulgin-apps-wrapper {
		.plugin-list-wrapper {
			width: unset;
		}
		.docs-link {
			margin-top: unset;
		}
	}
}
@media (max-width: 550px) {
	.pulgin-apps-wrapper {
		.header-wrapper {
			text-align: center;
			.title-wrapper {
				flex-direction: column;
				align-items: center;
				.title-content-wrapper {
					margin-top: 0;
					display: flex;
					flex-direction: column;
					align-items: center;
				}
			}
			.plugin-icon {
				width: 7rem;
				height: 7rem;
				margin-top: 0px;
			}
		}
		.plugin-list-wrapper {
			text-align: center;
				.plugin-list-item {
					.plugin-list-icon {
						width: 5rem;
						height: 5rem;
					}
				}
		}
		.sub-title-content-wrapper {
				.filter-content {
					width: 100%;
				}
		}
	}
}
@media (max-width: 450px) {
	.pulgin-apps-wrapper {
		.footer-links-wrapper, .title-content, .scrool-hearder-wrapper, .header-links {
			flex-direction: column;
			text-align: center;
			align-items: center;
			.about-wrapper,.blog-wrapper {
				margin-top: 5%;
			}
		} 
		.header-wrapper {
			.title-wrapper {
				.title-content-wrapper {
					line-height: 1rem;
				}
			}
		}
		.plugin-list-wrapper {
				.plugin-list-item {
					.plugin-list-icon {
						width: 5rem;
						height: 5rem;
					}
					.description-content  > p {
						margin-left: 0rem !important;
					}
				}
				.plugin-card-wrapper {
					display: flex;
    				flex-direction: column;
					.icon-wrapper {
						margin-bottom: 1rem;
					}
				}
		}
	}
}
`;

export const PluginDetailsWrapper = styled.div`
	.Plugin-detail-wrapper {
		width: 60rem;
		margin-left: auto;
		margin-right: auto;
		margin-top: 3rem;
		.myplugin-explore {
			font-size: 16px;
			color: #ffffff;
			text-decoration: underline;
		}
		.myplugin-link {
			font-size: 16px;
			color: #ffffff;
			text-decoration: unset;
			margin-left: 5px;
		}
		.d-flex {
			display: flex;
		}
		.bold {
			font-weight: bold;
		}
		.card-version-label {
			margin-left: 5px;
		}
		.header {
			font-size: 18px;
			margin-bottom: 5px;
		}
		.version-content {
			font-size: 12px;
   			margin: 8px 0px 0px 8px;
		}
		.plugin-detail-card-warpper {
			margin-top: 2rem;
			.verify-badge-wrapper{
				margin: 0px 5px 0px 5px;
				width: 20px;
				height: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.verify-badge-icon {
				width: 15px;
				height: 15px;
				margin-top: 3px;
			}
			.verify-badge-icon:hover{
				width: 20px;
				height: 20px;
			}
			.plugin-detail-icon {
				height: 4rem !important;
			}
			.sub-header {
				margin-right: 5px;
			}
			.tooltip-container {
				margin: 0px;
			}
			.info-circle {
				color: #fff;
				margin: 0px 5px 0px 5px;
			}
			.render-btn {
				width: 30%;
				border-radius: 15px;
    			height: 25px;
				margin-top: 10px;
			}
			.plugin-card-img {
				width: 17rem;
				height: 10rem;
			}
			.one-time-activation-icon {
				width: 16px;
				height: 20px;
				margin: 0px 5px 0px 5px;
			}
			.custom-free{
				color: white;
				border: 1px solid #00781b8c;
				border-radius: 12px;
				padding: 5px;
				margin-left: 5px;
				font-size: 12px !important;
				}
			.card-wrapper {
				margin-left: 3rem;
				.slider-arrow-right {
					border-style: solid;
					border-width: 0 2px 2px 0;
					display: inline-block;
					padding: 3px;
					height: 1.5rem;
					width: 1.5rem;
					color:#707070;
					rotate: 135deg;
					margin-top: 4rem;
				}
				.slider-arrow-left {
					border-style: solid;
					border-width: 0 2px 2px 0;
					display: inline-block;
					padding: 3px;
					height: 1.5rem;
					width: 1.5rem;
					color: #707070;
					rotate: 315deg;
					margin-top: 4rem;
				}
				.plugin-card-content {
					margin-top: 1rem;
				}
			}
		}
		.plugin-divider {
			border-bottom: 1px solid #B9B9B9 ;
			position: relative;
			right: 24px;
			top: 5rem;
			width: calc(100% + 48px);
		}
		.about-wrapper {
			margin-left: 2rem;
			.about-label {
				margin-top: 3rem;
				font-size: 20px;
				border-bottom: 3px solid #ffffff;
				width: 10rem;
				color: #fff;
			}
			.about-title, .about-footer {
				margin-top: 2rem;
			}
		}
	}
@media (max-width: 1440px) {
	.Plugin-detail-wrapper {
		margin-top: unset;
		padding: 3rem;
	}
}	
@media (min-width: 850px) and (max-width: 1024px) {
	.Plugin-detail-wrapper {
		width: unset;
		padding: 5rem;
	}
}	
@media (max-width: 849px) {
	.Plugin-detail-wrapper {
		width: unset;
		padding: 5rem;
		.plugin-detail-card-warpper {
			.detail-content-wrapper {
				flex-direction: column;
			}
			.render-btn {
				margin-bottom: 2rem;
			}
			.card-wrapper {
				margin-left: 0px;
				.slider-arrow-left {
					height: 10px;
					width: 10px;
					margin: 3rem 0rem 0rem 0rem;
				}
				.slider-arrow-right {
					height: 10px;
					width: 10px;
					margin: 3rem 0rem 0rem 0rem;
				}
				.plugin-card-img {
				width: 13rem;
				height: 7rem;
				}
			}
		}
		.plugin-divider {
			width: unset;
		}
	}
}
@media (max-width: 549px){
	.Plugin-detail-wrapper {
		.plugin-detail-content-wrapper{
			flex-direction: column;
			.plugin-detail-icon {
				height: 5rem !important;
				width: 5rem;
				margin:0rem 0rem 1rem 0rem;
			}
		}
			.card-wrapper {
				.slider-arrow-left {
					height: 10px;
					width: 10px;
					margin: 1rem 0rem 0rem 0rem;
				}
				.slider-arrow-right {
					height: 10px;
					width: 10px;
					margin: 1rem 0rem 0rem 0rem;
				}
				.plugin-card-img {
				width: 9rem !important;
				height: 6rem !important;
				}
			}
			.about-wrapper {
				.about-label {
					width: 4rem !important;
				}
			}
	}
}
@media (max-width: 300px){
	.Plugin-detail-wrapper {
		padding: 2rem;
	}
}
`;
